import React from 'react'
function PaymentModesAvailable() {
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_layout">
               <h1>Payment Modes Available</h1>
               <hr/>
               <p class="mt-30">Safexpay Checkout offers multiple payment methods for your customers to choose from, improving their experience and increasing the chances of successful transactions.</p>
               <p>
                  This improves user experience and allows you to offer alternate payment methods to your customer in the case of downtimes or low success rate with one of the payment methods. For example, if you are facing downtime with net banking, the customer can complete the payment using cards or wallets.
               </p>
               <p>
                  The available payment modes include:
               </p>
               <ul>
                  <li><b>Debit Card:</b> allows customers to pay using their debit card issued by any bank in India. </li>
                  <li><b>Credit Card:</b> allows customers to pay using their credit card issued by any bank in India or internationally. </li>
                  <li><b>Net Banking:</b> allows customers to pay using their bank's internet banking facility.</li>
                  <li><b>UPI: </b>allows customers to pay using their UPI-enabled bank account, making transactions quick and easy.</li>
                  <li><b>Pay Later:</b> allows customers to defer payment for their purchase and pay later through various financing options.</li>
                  <li><b>Wallet:</b> allows customers to pay using digital wallets like Paytm, Mobikwik, Freecharge, etc.
                     Some wallets may require approval from Safexpay before they can be enabled. Simply contact our Support Team to request approval.
                  </li>
               </ul>
            </section>
         </div>
         <div class="col-md-4">
         </div>
      </div>
   </div>
</div>
)
}
export default PaymentModesAvailable